import img1 from '../assets/img/gallery/1.jpg';
import img2 from '../assets/img/gallery/2.jpg';
import img3 from '../assets/img/gallery/3.jpg';
import img4 from '../assets/img/gallery/4.jpg';
import img5 from '../assets/img/gallery/5.jpg';
import img6 from '../assets/img/gallery/6.jpg';
import img7 from '../assets/img/gallery/7.jpg';
import img8 from '../assets/img/gallery/8.jpg';
import img9 from '../assets/img/gallery/9.jpg';
import img10 from '../assets/img/gallery/10.jpg';
import img11 from '../assets/img/gallery/11.jpg';
import img12 from '../assets/img/gallery/12.jpg';
import img13 from '../assets/img/gallery/13.png';
import img14 from '../assets/img/gallery/14.jpeg';
import img15 from '../assets/img/gallery/15.png';
import img16 from '../assets/img/gallery/16.png';
import img17 from '../assets/img/gallery/17.png';
import img18 from '../assets/img/gallery/18.png';
import img19 from '../assets/img/gallery/19.jpg';
import img20 from '../assets/img/gallery/20.jpg';
import img21 from '../assets/img/gallery/21.jpg';
import img22 from '../assets/img/gallery/22.jpg';
import img23 from '../assets/img/gallery/23.jpg';
import img24 from '../assets/img/gallery/24.jpg';
import img25 from '../assets/img/gallery/25.png';
import img26 from '../assets/img/gallery/26.jpg';
import img27 from '../assets/img/gallery/27.jpg';
import img28 from '../assets/img/gallery/28.png';
import img29 from '../assets/img/gallery/29.jpg';
import img30 from '../assets/img/gallery/30.png';
import img31 from '../assets/img/gallery/31.png';
export const data = [
    {
        id: 1,
        imgSrc: img1,
    },
    {
        id: 2,
        imgSrc: img2,
    },
    {
        id: 3,
        imgSrc: img3,
    },
    {
        id: 4,
        imgSrc: img4,
    },
    {
        id: 5,
        imgSrc: img5,
    },
    {
        id: 6,
        imgSrc: img6,
    },
    {
        id: 7,
        imgSrc: img7,
    },
    {
        id: 8,
        imgSrc: img8,
    },
    {
        id: 9,
        imgSrc: img9,
    },
    {
        id: 10,
        imgSrc: img10,
    },
    {
        id: 11,
        imgSrc: img11,
    },
    {
        id: 12,
        imgSrc: img12,
    },
    {
        id: 13,
        imgSrc: img13,
    },
    {
        id: 14,
        imgSrc: img14,
    },
    {
        id: 15,
        imgSrc: img15,
    },
    {
        id: 16,
        imgSrc: img16,
    },
    {
        id: 17,
        imgSrc: img17,
    },
    {
        id: 18,
        imgSrc: img18,
    },
    {
        id: 19,
        imgSrc: img19,
    },
    {
        id: 20,
        imgSrc: img20,
    },
    {
        id: 21,
        imgSrc: img21,
    },
    {
        id: 22,
        imgSrc: img22,
    },
    {
        id: 23,
        imgSrc: img23,
    },
    {
        id: 24,
        imgSrc: img24,
    },
    {
        id: 25,
        imgSrc: img25,
    },
    {
        id: 26,
        imgSrc: img26,
    },
    {
        id: 27,
        imgSrc: img27,
    },
    {
        id: 28,
        imgSrc: img28,
    },
    {
        id: 29,
        imgSrc: img29,
    },
    {
        id: 30,
        imgSrc: img30,
    },
    {
        id: 31,
        imgSrc: img31,
    },
]